/**
 * @desc: 受理复核
 * @created: 2020/5/6
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T3/riskControlReview'

export default {
  namespaced: true,
  actions: {
    // 获取列表查询数据
    getListData(ctx, payload) {
      return Models.getListData(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 获取总览分析数据 (items)
    getAnalyzeData(ctx, payload) {
      return Models.getAnalyzeData(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 总览分析 风控数据 图表数据(小时)
    getAnalyzeRiskHours(ctx, payload) {
      return Models.getAnalyzeRiskHours(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 总览分析 风控数据 图表数据联合运算
    getAnalyzeRiskJoint(ctx, payload) {
      return Models.getAnalyzeRiskJoint(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 总栏分析 渠道风控统计表
    getAnalyzeBankData(ctx, payload) {
      return Models.getAnalyzeBankData(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 总栏分析 收单机构风控统计表
    getAnalyzeCompanys(ctx, payload) {
      return Models.getAnalyzeCompanys(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 渠道分析图表数据
    getChannelBankJoint(ctx, payload) {
      return Models.getChannelBankJoint(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 渠道划分表格列表数据
    getChannelBankList(ctx, payload) {
      return Models.getChannelBankList(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 获取收单机构划分 列表数据
    getCompanysList(ctx, payload) {
      return Models.getCompanysList(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 获取收单机构划分 线形图
    getCompanyRiskLine(ctx, payload) {
      return Models.getCompanyRiskLine(payload).then(res => {
        return res && res.status === 200 && res.data || []
      })
    },

    // 获取收单机构划分 饼图
    getCompanyRiskPie(ctx, payload) {
      return Models.getCompanyRiskPie(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 关系验证-相关联系人列表
    listContacts(ctx, payload) {
      return Models.listContacts(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 关系验证-相关法人列表
    listRelationCorps(ctx, payload) {
      return Models.listRelationCorps(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 关系验证-相关地理信息列表
    listRelationGeographicInfo(ctx, payload) {
      return Models.listRelationGeographicInfo(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    },

    // 关系验证-用户匹配信息列表
    listUserMatchingInfor(ctx, payload) {
      return Models.listUserMatchingInfor(payload).then(res => {
        return res && res.status === 200 && res.data || {}
      })
    }
  }
}
